import { render, staticRenderFns } from "./diy-model-template.vue?vue&type=template&id=c508ae02&scoped=true&"
import script from "./diy-model-template.vue?vue&type=script&lang=js&"
export * from "./diy-model-template.vue?vue&type=script&lang=js&"
import style0 from "./diy-model-template.vue?vue&type=style&index=0&id=c508ae02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c508ae02",
  null
  
)

export default component.exports